export const CURRENT_CONTACT_UPDATE = "[main] current contact update";
export const CURRENT_CONTACT_NULL = "[main] current contact null";
export const SET_SPOTLIGHT_UPDATE = "[main] spotlight update";
export const SET_SHOW_MODAL = "[main] modal update";
export const UPDATE_CONTACT_MESSAGES = "[main] update contact messages";
export const PREV_MEDIA = "[main] previous media";
export const CURRENT_MEDIA = "[main] current media";
